export function sanitizeNames(name) {
  return name
    .replace(/å/g, 'aa')
    .replace(/Å/g, 'Aa')
    .replace(/æ/g, 'ae')
    .replace(/Æ/g, 'Ae')
    .replace(/ø/g, 'o')
    .replace(/Ø/g, 'O')
    .replace(/á/g, 'a')
    .trim()
}



// WEBPACK FOOTER //
// ./src/lib/sanitizeNames.js